import { ImportTemplateListResponse } from "../../../shared/entities/ImportTemplateListResponse";
import { TranslationService } from "../../../../services/TranslationService";
import ImportTemplateEditBase, { ImportTemplateComponentProps } from "./ImportTemplateEditBase";
import EditItem from "./Components/EditItem";
import { TextEditor } from "../../../shared/components/Editors";
import { GroupBy, OptionalMap } from "../../../../utils/Utils";
import { useCallback, useEffect, useState } from "react";
import ImportTemplateService from "../../../../services/ImportTemplateService";
import DictionaryService from "../../../../services/DictionaryService";
import { useHistory } from "react-router-dom";
import { ImportService } from "../../../../services/ImportService";

const DICTIONARY_ENTITY = 11;

const ImportTemplateEditDictionaryManual = () => {
    const { translate } = TranslationService;
    const history = useHistory();
    const state = history.location.state;
    const ImportTemplateID = (state as any)?.ImportTemplateID;

    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState<ImportTemplateListResponse.Item | undefined>();

    const importDefinitions = ImportService.getImports();
    const order = [DICTIONARY_ENTITY];


    const requestData = async () => {
        try {
            const dictPromise = DictionaryService.getList();
            const result = await ImportTemplateService.getList();
            const dictionaries = await dictPromise;
            if (result instanceof Error || dictionaries instanceof Error) {
                return;
            }
            const groupImports = OptionalMap(result, x => Object.values(GroupBy(x.list, y => y.Entity))) ?? [];
            const sortedGroupImports = order.filter(x => importDefinitions[x].isEnabled).map(x => groupImports.find(y => y[0].Entity === x)!).filter(x => x);

            const dictionaryList = result.list.filter(x => x.Entity === DICTIONARY_ENTITY)
            dictionaryList.forEach(y => { y.Name = dictionaries.list.find(x => x.ImportTemplateID === ImportTemplateID)?.Name ?? y.Name; });
            dictionaryList.map(x => groupImports.find(y => y[0].Entity === x.Entity)!);

            const item = dictionaryList.find(x => x.ImportTemplateID === ImportTemplateID);
            const importDetected = sortedGroupImports[0].find(imp => imp.Name === (state as any)?.Name);
            console.log({
                item, importDetected, state, sortedGroupImports: sortedGroupImports[0]
            })
            setData(importDetected)
            setIsLoading(false)
        } catch (error) {
            console.error(error)
        } finally {
            setIsLoading(false)
        }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const requestDataCallback = useCallback(requestData, []);
    useEffect(() => {
        requestDataCallback();
    }, [requestDataCallback]);


    const Header = () => {
        return (<div className="mb-3 mt-4">
            <h5 className="mb-4">{translate.DictionaryImportSettings}</h5>
            <details className="mt-3">
                <summary className="ps-1"><h6 style={{ display: "unset" }}>{translate.SeeTheRequirementsOfTheFileToImport}</h6></summary>
                {translate.RequirementsOfTheFileToImport.split("\n").map((x, i) => <div key={i} className="text-muted ps-3">{x}</div>)}
            </details>
        </div>);
    };

    const AdvancedOptions = ({ data, updateModel }: ImportTemplateComponentProps) =>
        <EditItem label={<>{translate.SendResultsTo}</>} ><TextEditor onChange={updateModel("EmailReturn")} defaultValue={data?.EmailReturn} /></EditItem>;
    return !isLoading ? (
        <div className="container">
            <ImportTemplateEditBase entityId={DICTIONARY_ENTITY} Header={Header} reload={() => { }} requiredFieldIds={[]} data={data} AdvancedOptions={AdvancedOptions} />
        </div>
    ) : null;
};

export default ImportTemplateEditDictionaryManual;